export default __webpack_public_path__ + "static/media/WG LOGO.263b5a99.jpg";